import { useState, useEffect } from 'react';
import { getFitUrl } from '@/utils';
import { useMediaQuery } from 'react-responsive';
import _default from '@/assets/img/default.png';

type AdaptImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  alt?: string;
  width: {
    h5: number;
    pad: number;
    pc: number;
  };
  quality?: number;
};
/**
 * @description 适配图片
 * @param param0
 * @returns
 */
export const AdaptImage = ({ src = _default, alt, ...rest }: AdaptImageProps) => {
  const { width, quality = 75 } = rest;
  const [currentWidth, setCurrentWidth] = useState(width.h5);

  const isPad = useMediaQuery({ query: '(min-device-width: 768px) and (max-device-width: 1024px)' });
  const isPc = useMediaQuery({ query: '(min-width: 1025px)' });

  useEffect(() => {
    if (isPad) {
      setCurrentWidth(width.pad);
    } else if (isPc) {
      setCurrentWidth(width.pc);
    } else {
      setCurrentWidth(width.h5);
    }
  }, [isPad, isPc]);

  const imgUrl = getFitUrl(src, { w: currentWidth, q: quality });
  return <img src={imgUrl} alt={alt || ''} {...rest} />;
};
/**
 * @description 适配图片,返回地址
 * @param url {string}
 * @param width number
 * @param q number
 * @returns string
 */
export const getAdaptUrl = (url?: string, width?: number, quality = 75) => {
  if (!url) return _default;
  width = width || document.body.clientWidth;
  return getFitUrl(url, { w: width, q: quality });
};
